export function extractProductId(url: string): string {
  const matchResult = url?.match(/\/product\/.*-(\d+)\/?(\?.+)?$/);
  return matchResult ? matchResult[1] : '';
}
